import axios from 'axios'

export default {
  methods: {
    updateUserActivity(platform, activity, activityValue) {
      const params = {
        userActivity: {
          platform: platform,
          activity: activity,
          activityValue: activityValue,
          metadata: {
            userAgent: window.navigator.userAgent,
          },
        },
      }

      axios({
        method: 'post',
        url: 'user_activities',
        data: params,
      })
        .then(response => {
          console.log('updateUserActivity response', response)
        })
        .catch(error => {
          console.error('updateUserActivity error', error)
        })
    },
  },
}
